import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";
import UnlabelledComparisonChart from "../charts/UnlabelledComparisonChart";
import DisaggregateMetricCard from "../DisaggregateMetricCard";

const LivabilityMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const familyOrders = getMetricGroupOrderIds(tab);

    const sortedLivabilityMetrics = familyOrders.map((order: number[]) => 
        categorizedData["Livability"]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Livability data:', sortedLivabilityMetrics);

    const livability: DisaggregatedMetric[] = sortedLivabilityMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the indexMetric from metadata based on the current tab
    const indexMetricId = metadata?.find((metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === tab.toLowerCase())?.id || 0;

    // Find the full indicator object that matches indexMetric
    const indexMetricData = indicators.find(metric => metric.id === Number(indexMetricId)) || null;

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            <p className="text-lacey-text mx-4 text-[10px] mb-4">Data updates published April 17th, 2025.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {livability.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                {/* Crime */}
                { categorizedData['Livability'].some(metric => metric.id === 1183) &&
                <div className="col-span-2 w-full pr-4 mb-4">
                    <div className="bg-anti-flash pb-2">
                        {categorizedData.Livability.filter(metric => 
                            [getMetricGroupChartId(tab, "crime")].includes(metric.id) // Crime
                        ).map(metric => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                title={metric.name}
                                svg={getSvgMap(metric.id)}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                            />
                        ))}

                        <div className="relative w-full">
                            {/* Vertical red line at 200px, covering both bars */}
                            <div className="absolute top-4 bottom-2 w-[2px]" style={{ left: '238px', backgroundColor: 'rgba(239, 68, 68, 0.4)' }}></div>

                            <UnlabelledComparisonChart indicators={indicators} title="Crime" tab="Livability" chartName="crime" height="h-24" barColor="#00A18A"/>

                            <p className="text-color-cai-gray text-[9px] absolute -bottom-2" style={{ left: '202px' }}>National Average</p>
                        </div>
                            
                        <p className="text-[#4D4D4D] text-[11px] ml-6 my-4">{categorizedData.Livability.filter(metric => 
                            [getMetricGroupChartId(tab, "crime")].includes(metric.id) // Crime Risk
                        ).map(metric => metric.versions[0].unit_descriptor)}</p>
                    </div>
                </div>
                }
            </div>
        </>
    );
}

export default LivabilityMetrics;